import { createContext } from "react"

/** True for anything rendered inside a Modal. */
export const InsideModalContext = createContext(false)
